import React from "react";
import { useQuery } from "@apollo/client";
import { MY_HR_GET_IMPORT_EMPLOYEE_LIST } from "my-hr/graphql";
import { OcErrorBoundary, OcFilterItem } from "oc/components";
import { useOcFiltersData, useOcPolling, useOcQueryParams } from "oc/hooks";

interface OcEmployeeImportFilterProps {
  roleFilters: {
    contract?: any[];
    orgUnit?: any[];
    [key: string]: any;
  };
  onAddFilter: (...args: any[]) => void;
  onRemoveFilter: (...args: any[]) => void;
  product?: any;
  role?: any;
  contract?: any;
}

export const OcEmployeeImportFilter = ({
  roleFilters,
  onAddFilter,
  onRemoveFilter,
  product,
  role,
  contract,
}: OcEmployeeImportFilterProps) => {
  let filterType = "contract";

  const entity = { contracts: roleFilters?.contract || [] };
  const stateId = "employeeImportFilter";

  const { search, setSearch, setPageSize, queryParams } = useOcQueryParams({
    stateId,
    entity,
    product,
    role,
    contract,
  });

  const {
    data: rawData,
    loading,
    fetchMore,
  } = useQuery(MY_HR_GET_IMPORT_EMPLOYEE_LIST, {
    fetchPolicy: "cache-and-network",
    pollInterval: useOcPolling(1000 * 60),
    notifyOnNetworkStatusChange: true,
    variables: queryParams,
  });

  const data = rawData?.importEmployeeList;

  const fetchMoreVoid = (...args: Parameters<typeof fetchMore>) => {
    void fetchMore(...args);
  };

  const {
    availableItems,
    selectedItems,
    handleFetchMore,
    handleSearch,
    handleClearSearch,
  } = useOcFiltersData({
    data,
    fetchMore: fetchMoreVoid,
    setSearch,
    setPageSize,
    entityLength: roleFilters?.orgUnit?.length || 0,
    //selectAll: true,
    product,
    role,
    filterType,
  });

  type ItemType = { code: string; name: string };

  const parsedAvailableItems = (availableItems || []).map((item: ItemType) => {
    return {
      code: item.code,
      name: `${item.name.replaceAll("|", " ").trim()}`,
    };
  });

  const parsedSelectedItems = (selectedItems || []).map((item: ItemType) => {
    return {
      code: item.code,
      name: `${item.name.replaceAll("|", " ").trim()}`,
    };
  });

  return (
    <OcErrorBoundary>
      <OcFilterItem
        filterType={filterType}
        selectedItems={parsedSelectedItems || []}
        availableItems={parsedAvailableItems}
        search={search}
        onSearch={handleSearch}
        onClearSearch={handleClearSearch}
        onAddFilter={onAddFilter}
        onRemoveFilter={onRemoveFilter}
        onLoading={loading}
        onFetchMore={handleFetchMore}
        showLists={true}
      />
    </OcErrorBoundary>
  );
};

export default OcEmployeeImportFilter;
